"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLayoutFooterBase = exports.AppLayoutFooter = void 0;
var _react = _interopRequireDefault(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _utils = require("../../utils");
var _composeStencilComponent = require("../../utils/composeStencilComponent");
var _Row = _interopRequireDefault(require("../Row"));
var _helperComponents = require("./helperComponents");
var _react2 = require("@emotion/react");
const AppLayoutFooterBase = _ref => {
  let {
    children,
    ...wrapperProps
  } = _ref;
  return (0, _react2.jsx)(_helperComponents.ContentWrapper, {
    wrapperProps: wrapperProps
  }, children);
};
exports.AppLayoutFooterBase = AppLayoutFooterBase;
const AppLayoutFooter = exports.AppLayoutFooter = (0, _composeStencilComponent.composeStencilComponent)({
  baseComponent: AppLayoutFooterBase,
  displayName: 'AppLayoutFooter',
  description: 'The footer section of the layout, used for displaying copyright information, links to privacy policies, terms of service, and other content that should be consistently displayed at the bottom of the page.',
  propTypes: {
    ...(0, _utils.omit)(_Row.default.describedPropTypes, ['children']),
    children: _stencilReactDesc.PropTypes.node.description('Contains footer elements')
  }
});